import axios from "axios";
import { useState } from "react";
import { API_URL } from "../const/api";
import { errorNotification } from "../utils/toastNotifications";
import { UAParser } from "ua-parser-js";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY, SUCCESS } from "../const/colors";
import { useDispatch } from "react-redux";
import { setShowUserRegisterModal } from "../features/modals/modalsSlice";
import { useTranslation } from "react-i18next";

export const useForm = (initialForm, validateForm) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  const handleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setForm({ ...form, [name]: value });
    } else {
      if (e.name === "codigoAgente") {
        setForm({ ...form, codigoAgente: e.value });
      }
    }

    //setErrors(validateForm(form));
  };

  const handleRadioChange = (e) => {
    const { name, checked } = e.target;
    setForm({ ...form, [name]: checked });
  };

  const handleCountry = (value) => {
    setForm({ ...form, countryCode: value });
  };

  const handleBlur = async (e) => {
    const {name, value} = e.target;
    handleChange(e);
    setErrors(validateForm({...form, [name]: value}));
  };
  const handleRadioBlur = (e) => {
    handleRadioChange(e);
    setErrors(validateForm(form));
  };

  const handleClear = () => {
    setForm(initialForm);
    setErrors([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors(validateForm(form));
    if (errors.length === 0) {
      for (const val in form) {
        if (form[val] === "") {
          errorNotification("Por favor, rellene todos los campos.");
          return;
        }
      }
    }
    if (Object.keys(validateForm(form)).length === 0) {
      setLoading(true);
      const parser = new UAParser();
      const browser = parser.getResult().browser;
      const engine = parser.getResult().engine;
      const os = parser.getResult().os;
      const device = parser.getResult().device;
      const cpu = parser.getResult().cpu;
      const body = {
        ...form,
        telefono: form.countryCode + " " + (form.area || '') + form.telefono,
        cedula: form.cedula + (form.letraONumero || ''),
        browser: browser.name + "-" + browser.version,
        engine: engine.name + "-" + engine.version,
        os: os.name + "-" + os.version,
        device: device.model + "-" + device.type + "-" + device.vendor,
        cpu: cpu.architecture,
      };
      const sendData = async () => {
        try {
          const res = await axios.post(API_URL + "registroUsuario", body);
          if (!(res.data.response.error === 1 && res.data.response.data.includes('error al enviar correo')) &&
            res.data.response.error !== 1) {
            if(res.data.response.message && res.data.response.message==='ludopata') {
              Swal.fire({
                title: `<strong>Error al registrarse</strong>`,
                text: 'Ha ocurrido un error en el registro, por favor comunicarse con el soporte técnico.',
                icon: "error",
                showCloseButton: true,
                focusConfirm: false,
                allowOutsideClick: false,
                confirmButtonText: `<a href="http://wa.me/593987369585" target="_blank">Soporte</a>`,
                background: SECONDARY,
                color: "#fff",
                confirmButtonColor: PRIMARY,
              });
              setLoading(false);
              handleClear();
              dispatch(setShowUserRegisterModal(false));
            } else {
               Swal.fire({
                title: `<strong>${t("modal-success-register.title")}</strong>`,
                text: t("modal-success-register.info"),
                icon: "success",
                showCloseButton: true,
                focusConfirm: false,
                allowOutsideClick: false,
                confirmButtonText:  `<strong>${t("modal-success-register.btnAccept")}</strong>`,
                background: SECONDARY,
                color: "#fff",
                confirmButtonColor: PRIMARY,
                showCancelButton: false,
              });
              setLoading(false);
              handleClear();
              dispatch(setShowUserRegisterModal(false));
            }
          } else {
            setLoading(false);
            res.data.response.data.forEach((error) => errorNotification(error));
          }
        } catch(error) {
          setLoading(false);
          if (!error.response || error.code === 'ERR_NETWORK') {
            errorNotification("Tuvimos problemas para conectar con el servidor. Por favor, verifique su conexión a internet e intente nuevamente.");
          } else {
            errorNotification("Ocurrió un error al registrarte. Intenta nuevamente más tarde.");
          }
          console.log("error en registro",error)
        }
      };
      sendData();
    } else {
      const error = validateForm(form);
      for (const val in error) {
        errorNotification(error[val]);
        return;
      }
    }
  };

  return {
    form,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
    handleRadioChange,
    handleRadioBlur,
    handleCountry,
    handleClear,
    loading,
  };
};
